import displayType from './displayType';

export default displayType;
